import React, { Component } from 'react';
import { Provider, connect } from 'react-redux';
import { Router, Route, Switch, Redirect } from 'react-router-dom'

import { Loader } from 'semantic-ui-react';
import 'react-datepicker/dist/react-datepicker.css';
import 'semantic-ui-css/semantic.min.css';

import { store } from './store';
import history from './history'
import * as paths from './constants'
import LanguageService from './services/languageService'
import Login from './views/login';
import Dashboard from './views/dashboard';
import PlanView from './views/plan';
import PlanScope from './views/plan_scope/index';
import ResetPassword from './views/password/reset';
import ChangePassword from './views/password/change';
import AdminView from './views/admin_template';
import Users from './views/users';
import LibraryControls from './views/control_library';
import { getTranslations } from './actions/language'
import PlanUploadChannel from './components/plan_upload_channel';
import { toolTipManager } from './services/instanceService';

import './App.css';

const languageService = new LanguageService()

class App extends Component {
  constructor(props){
    super(props);
    this.state = {
      tooltipsLoaded: false,
    }
  }

  async componentDidMount() {
    const language = 'English';
    getTranslations(language);

    await toolTipManager.init();
    this.setState({ tooltipsLoaded: true });
  }

  render() {
    if (!this.state.tooltipsLoaded) {
      return <Loader active inline="centered" size="large">Loading...</Loader>;
    }
    return (
      <Provider store={store}>
        <div className="app">
          <PlanUploadChannel />
          <Router history={history}>
            <div>
              <Switch>
                <Route exact path={paths.LOGIN_PATH} component={Login} />
                <Route exact path={paths.DASHBOARD_PATH + '/:activeItem'} component={Dashboard} />
                <Route
                  exact
                  path={paths.LOAD_PLAN_PATH}
                  component={(props) => <PlanView {...props} LanguageService={languageService} />}
                />
                <Route exact path={paths.PLAN_ACTIVITIES_PATH} component={PlanScope} />
                <Route exact path={paths.PASSWORD_RESET_PATH} component={ResetPassword} />
                <Route exact path={paths.PASSWORD_CHANGE_PATH} component={ChangePassword} />
                <Route
                  exact
                  path={paths.ADMIN_TEMPLATE_PATH}
                  component={(props) => <AdminView {...props} LanguageService={languageService} />}
                />
                <Route exact path={paths.USERS_PATH} component={Users} />
                <Route exact path={paths.LIBRARY_CONTROLS_PATH} component={LibraryControls} />

                <Route
                  render={() => (
                    <Redirect to={this.props.token ? paths.DASHBOARD_PATH + '/risk_plans' : paths.LOGIN_PATH} />
                  )}
                />
              </Switch>
            </div>
          </Router>
        </div>
      </Provider>

    );
  }
}

const mapStateToProps = (state) => ({
  token: state.app_token.accessToken,
});

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js